"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisualWrapper = exports.TextContainer = exports.ImagetextWrapper = exports.ImageContent = exports.Image = exports.Headline = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const setContainerWidth = width => {
  switch (width) {
    case 'normal':
      return (0, _layout.setContainer)({
        size: 'lg'
      });
      break;
    case 'wide':
      return (0, _layout.setContainer)({
        size: 'xl'
      });
      break;
    default:
      return (0, _layout.setContainer)({
        size: 'lg'
      });
      break;
  }
};
const ImagetextWrapper = _styledComponents.default.div`
  ${props => setContainerWidth(props.fullWidth)};
  ${props => !props.textWrap && `
    display: flex;
    @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      flex-direction: column;
      align-items: center;
    }
  `};
  position: relative;
`;
exports.ImagetextWrapper = ImagetextWrapper;
const VisualWrapper = _styledComponents.default.div`
  ${props => !props.textWrap && `
   display: flex;
   order: ${props.imageAlignment == 'left' ? 0 : 1};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    width: 100%;
  }
 `};
  ${props => props.textWrap && `
  float: ${props.imageAlignment};
  padding: ${props.imageAlignment == 'left' ? '0 20px 0 0' : '0 0 0 20px'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    float: none;
    padding: 0;
    width: 100%;
  }
 `};
  width: 50%;
  &.animation-transform {
    will-change: opacity;
  }
`;
exports.VisualWrapper = VisualWrapper;
const ImageContent = _styledComponents.default.div`
  ${props => props.showOnlyOnDesktop && `
    @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      display: none;
    }
  `}
  ${props => props.mobile && `
    width: 100%;
    @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      display: none;
    }
`}
`;
exports.ImageContent = ImageContent;
const Image = _styledComponents.default.img`
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
`;
exports.Image = Image;
const TextContainer = _styledComponents.default.div`
  ${props => !props.textWrap && `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    order: ${props.imageAlignment == 'right' ? 0 : 1};
    @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      order: 1;
    }
    width: 50%;
    @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      width: 100%;
    }
    padding: 40px;
  `};
  ${props => props.textWrap && `
    text-align: justify;
    `};
  p {
    padding: 0;
    max-width: 100%;
    color: ${props => props.bodyColor || '#000'};
  }
`;
exports.TextContainer = TextContainer;
const Headline = _styledComponents.default.h3`
  ${(0, _typography.setFont)({
  headline: true
})};
  ${(0, _typography.setFontSizes)({
  xs: '24px',
  sm: '32px',
  xl: '48px'
})};
  color: ${props => props.headlineColor || '#000'};
  line-height: 1.09em;
  font-weight: normal;
  padding: 0;
  margin-top: 0;
`;
exports.Headline = Headline;
//# sourceMappingURL=styles.js.map